import { Col, ColType, Crud, CrudAction, CrudApi } from "../../comp/crud";
import {
    ApiClient,
    getRepaymentPlanStatusOpt,
    getPaidMethodOpt,
} from "../../api/ApiClient";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
    Modal,
    Typography,
    Tag,
    Image,
    Button,
    Toast,
    Popover,
    Tooltip
} from '@douyinfe/semi-ui';
import { IconBarChartHStroked } from "@douyinfe/semi-icons";
import { formatAmountZhCn, formatDate, renderPlatformTooltip, renderStatDetailContentPlan, renderPaidMethodTag,renderPeriodNo,renderRepaymentPlanStatusTag } from "../../utils";

let apiClient = ApiClient.getDefault();
const { Text } = Typography;

export default function MortgageLoanPaidByDate() {
    const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
    const crudApiRef = useRef<CrudApi>();
    const filterFormRef = useRef<any>();
    const [statDataObj, setStatDataObj] = useState({} as any);

    let cols: Col[] = [
        {
            name: "ID",
            key: "id",
            hideInEdit: true,
            hideInCreate: true,
            hideInList: true,
            type: ColType.NUMBER
        },
        {
            name: "出款日期",
            key: "paidDate",
            width: 150,
            type: ColType.DATE_RANGE,
            hideInCreate: true,
            showInFilter: true,
            render: (value: any, record: any) => {
                if (!record.paidDate) {
                    return <Text strong style={{ fontSize: 15 }}>汇总</Text>;
                }
                if(record.children){
                const d = record.paidDate;
                const dateStr = typeof d === 'string' ? d : formatDate(d);
                const dayOfWeek = new Date(dateStr).getDay();
                const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
                return (
                    <Text strong style={{ color: 'orange' }}>
                        {dateStr} 周{weekDays[dayOfWeek]}
                    </Text>
                );
                } else {
                    return (
                    <Text strong style={{ color: 'orange' }}>
                        {value}
                    </Text>
                );
                }
                
            },
        },
        {
            name: "客户ID",
            key: "leadId",
            width: 90,
            showInFilter: true,
            type: ColType.NUMBER,
            hideInEdit: true,
            hideInList: true,
        },
        {
            name: "客户姓名",
            key: "leadName",
            width: 90,
            type: ColType.STRING,
            hideInEdit: true,
            hideInCreate: true,
            showInFilter: true,
            render: (value, record, index) => {
                if(!value){
                    return '';
                }
                            return (
                                <>
                                <Tooltip content={<div>按揭专员: {record.agentName}<br/>销售: {record.saleName}</div>}>
                                <Typography.Text
                                    link
                                    type="primary"
                                    onClick={() => openMortgageLoanModal(record.leadId,record.leadName)}
                                >
                                    {value}({record.leadId})
                                </Typography.Text>
                                </Tooltip>
                                </>
                            );
            
                        },
        },
        {
                      name: "贷款平台",
                      key: "platform",
                      width: 150,
                      type: ColType.STRING,
                      showInFilter: true,
                      render: (text: any, record: any) => (
                        <Tooltip style={{maxWidth:350}} content={renderPlatformTooltip(record)}>
                            <Typography.Text mark>{text || "-"}</Typography.Text>
                            
                        </Tooltip>
                      ),
                    },
                    {
                                  name: "期数",
                                  key: "periodNo",
                                  width: 70,
                                  type: ColType.STRING,
                                  // 期数渲染: 手动创建的(蓝Tag)、客户自还的(橙Tag)、系统生成的(纯文本)
                                  render: renderPeriodNo
                                },
                               
                                {
                                  name: "还款日期",
                                  key: "dueDate",
                                  width: 90,
                                  type: ColType.DATE_RANGE,     // 日期范围筛选，筛选时转为 "startDate,endDate"
                                  showInFilter: true,
                                  defaultSortOrder: false,
                                },
                                 {
                                name: "状态",
                                key: "status",
                                width: 70,
                                render: (value, record, index) => renderRepaymentPlanStatusTag(value, record),
                                type: ColType.SELECT,
                                showInFilter: true,
                                hideInEdit: true,
                                hideInCreate: true,
                                getOptions: (row) => Promise.resolve(getRepaymentPlanStatusOpt())
                            },
                
                {
                    name: "出款金额",
                    key: "expense",
                    width: 90,
                    type: ColType.NUMBER,
                    render: (value, record, index) => {
                        
                        return (
                                <Typography.Text >{formatAmountZhCn(record.loanHelpRepaymentPlanAmount+record.cardHelpRepaymentPlanAmount
                                    +record.borrowAmount)}</Typography.Text>
                        );
                       
                    },
                },
                {
                    name: "信用卡代过账",
                    key: "postingHelpAmount",
                    width: 90,
                    type: ColType.NUMBER,
                    render: (value, record, index) => {
                        
                        return (
                                <Typography.Text >{formatAmountZhCn(record.postingHelpAmount)}</Typography.Text>
                        );
                       
                    },
                },
       
        
        {
            name: "出款人",
            key: "paidUserName",
            width: 80,
            type: ColType.STRING,
            hideInCreate: true,
            render: (value: any, record: any) => {
                if (record.loanType == 'BORROW') return <Text>{record.borrowerName}</Text>;
                return <Text>{record.paidUserName}</Text>;
            },
        },
        {
            name: "出款人",
            key: "outMoneyUserName",
            width: 80,
            type: ColType.STRING,
            showInFilter: true,
            hideInList: true,
        },
        {
            name: "利息",
            key: "interestAmount",
            width: 80,
            type: ColType.TEXT,
            showInFilter: false,
            hideInEdit: true,
            hideInCreate: true,
            render: (value: number) => (
                <Text type="warning">{formatAmountZhCn(value || 0)}</Text>
            ),
        },
        {
            name: '利息计算',
            key: 'interestAmount',
            width: 160,
            type: ColType.TEXT,
            showInFilter: false,
            hideInEdit: true,
            hideInCreate: true,
            render: (text: string, row: any) => {
                let detail = row.planInterestDetail;
                if (!detail) return '-';
                if (!detail.interestStartDate) {
                    return <><Tag>{detail.interestAmount} * {detail.interestRate}</Tag></>;
                }
                return (
                    <>
                        <span>{formatDate(detail.interestStartDate)}至{formatDate(detail.interestEndDate)}({detail.interestEndDateDesc}) </span>
                        <Tag>{detail.interestAmount} * {detail.interestRate} * {detail.interestDays}天</Tag>
                    </>
                );
            },
        },
        {
            name: '还款天数',
            key: 'paidDays',
            width: 70,
            type: ColType.STRING,
            hideInCreate: true,
        },
        {
                    name: '利息',
                    key: 'interestAmount',
                    width: 70,
                    type: ColType.TEXT,
                    showInFilter: false,
                    hideInEdit: true,
                    hideInCreate: true,
                    render: (value: number) => (
                        <Text type="warning">
                            {formatAmountZhCn(value || 0)}
                        </Text>
                    )
                },
        {
            name: "还款图片",
            key: "imageUrls",
            width: 70,
            type: ColType.STRING,
            hideInCreate: true,
            render: (value: any, record: any) => {
                if (!value) return '';
                return (
                    <Image width={40} height={40}
                        src={record.imageUrls && record.imageUrls.length > 0 ? record.imageUrls[0].url : ''}
                        preview={{ src: (record.imageUrls || []).map((item: any) => item.url) }}
                    />
                );
            },
        },
        // {
        //     name: "贷款类型",
        //     key: "loanType",
        //     width: 80,
        //     type: ColType.SELECT,
        //     showInFilter: true,
        //     getOptions: () => Promise.resolve(getLoanTypeItemOpt()),
        //     render: (value: string) => displayMortgageLoanType(value),
        // },
        // {
        //     name: "贷款平台",
        //     key: "platform",
        //     width: 100,
        //     type: ColType.STRING,
        //     showInFilter: true,
        //     hideInCreate: true,
        //     hideInEdit: true,
        // },
        // {
        //     name: "贷款编号",
        //     key: "loanNo",
        //     type: ColType.STRING,
        //     showInFilter: true,
        //     hideInList: false,
        //     hideInCreate: true,
        //     hideInEdit: true,
        //     width: 110,
        // },
        {
            name: "还款方式",
            key: "paidMethod",
            width: 100,
            type: ColType.SELECT,
            showInFilter: true,
            hideInEdit: true,
            hideInCreate: true,
            render: (value) => renderPaidMethodTag(value),
            getOptions: () => Promise.resolve(getPaidMethodOpt())
        },
        // {
        //     name: "按揭专员",
        //     key: "agentName",
        //     width: 80,
        //     type: ColType.STRING,
        //     showInFilter: true,
        //     hideInCreate: true,
        //     hideInEdit: true,
        // },
    ];

    const detailAction = (a: any) => {
        const w = window.open("about:blank");
        let queryParams = { ...crudApi?.getQueryParams(), type: 'all' };
        if (w != null) {
            const ids = crudApi?.getData()?.map((i: any) => i.leadId);
            const data = {
                id: a.leadId, ids, viewMode: true, visitMode: false,
                leadFrom: 'report', queryParams,
            };
            w.location.href = "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
        }
    };

    // 功能12: 打开贷款详情页面
  // 跳转到新窗口 /#/newleadLoan，传入客户ID和姓名
  // 对应二级页面 indexMortgageLoan.tsx (entityKey: mortgageLoan/listGroupPlatform)
  const openMortgageLoanModal = async (leadId: number, leadName: string) => {
    //setLeadId(leadId);
    //setMortgageLoanShow(true);
    //打开客户贷款
    const w = window.open("about:blank");
    if (w != null) {
      //获取表格data的id列表
      const data = {
        id: leadId,
        name: leadName,
      };
      w.location.href =
        "/#/newleadLoan?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

    // 默认近7天
    const nowDate = new Date();
    const startDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() - 6);
    const endDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate());
    const initFilterValues = { paidDate: [startDate, endDate] };
    const initParams = { paidDate: formatDate(startDate) + "," + formatDate(endDate) };

    useEffect(() => { queryStatCount(initParams); }, []);

    const queryStatCount = async (data: any) => {
        apiClient.request("/repaymentPlan/listPaidSum", "GET", data).then((resp: any) => {
            setStatDataObj(resp.data || {});
        });
    };

    const applyQuickDate = (s: Date, e: Date) => {
        const api = crudApiRef.current;
        if (!api) { Toast.info('页面加载中，请稍后再试'); return; }
        const formApi = filterFormRef.current;
        if (formApi) formApi.setValue('paidDate', [s, e]);
        api.refresh();
    };

    const today = new Date();
    const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    const PaidDateQuickButtons = () => {
        const yesterday = new Date(todayStart); yesterday.setDate(yesterday.getDate() - 1);
        const weekStart = new Date(todayStart);
        weekStart.setDate(weekStart.getDate() - (weekStart.getDay() || 7) + 1); // 本周一
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
        const nearDays = [
            { label: '今天', start: todayStart, end: todayStart },
            { label: '昨天', start: yesterday, end: yesterday },
            { label: '近3天', start: new Date(new Date(todayStart).setDate(todayStart.getDate() - 2)), end: todayStart },
            { label: '近7天', start: new Date(new Date(todayStart).setDate(todayStart.getDate() - 6)), end: todayStart },
            { label: '本周', start: weekStart, end: todayStart },
            { label: '本月', start: monthStart, end: todayStart },
            { label: '上月', start: lastMonthStart, end: lastMonthEnd },
        ];
        const months = Array.from({ length: 5 }, (_, i) => {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            return {
                label: `${d.getMonth() + 1}月`,
                start: new Date(d.getFullYear(), d.getMonth(), 1),
                end: new Date(d.getFullYear(), d.getMonth() + 1, 0),
            };
        });
        return (
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', margin: '4px 0 6px', flexWrap: 'wrap' }}>
                <span style={{ color: 'var(--semi-color-text-2)', fontSize: 12, fontWeight: 500 }}>出款日期:</span>
                {nearDays.map(item => (
                    <Button key={item.label} size="small" theme="light"
                        onClick={() => applyQuickDate(item.start, item.end)}>{item.label}</Button>
                ))}
                <span style={{ color: '#ddd', margin: '0 2px' }}>|</span>
                {months.map(item => (
                    <Button key={item.label} size="small" theme="light"
                        onClick={() => applyQuickDate(item.start, item.end)}>{item.label}</Button>
                ))}
            </div>
        );
    };

    const StatCards = () => {
        const d = statDataObj;
        if (!d ) return null;
        return (
            <div style={{ display: 'flex', gap: 0, marginBottom: 8, overflowX: 'auto' }}>
                {[
                   
                    { label: '代还金额', value: d.loanHelpRepaymentPlanAmount+d.cardHelpRepaymentPlanAmount, color: '#1677ff' },
                    { label: '代过账金额', value: d.cardHelpPostingPlanAmount, color: '#722ed1' },
                    { label: '出款金额', value: d.loanHelpRepaymentPlanAmount+d.cardHelpRepaymentPlanAmount+d.borrowAmount, color: '#fa8c16' },
                    { label: '借款金额', value: d.borrowAmount, color: '#fa8c16' },
                    { label: '借款归还', value: d.borrowReturnAmount, color: '#52c41a' },
                     { label: '支出合计', value: d.paidAmount, color: '#e91e63' },
                    { label: '客户数', value: d.leadCount, color: '#595959', isCount: true },
                    { label: '出款笔数', value: d.paidPlanCount, color: '#595959', isCount: true },
                ].map((item: any) => (
                    <div key={item.label} style={{
                        flex: '1 1 0', minWidth: 100, padding: '8px 12px',
                        background: 'var(--semi-color-bg-2)', borderRadius: 4,
                        textAlign: 'center', borderRight: '1px solid var(--semi-color-bg-0)',
                    }}>
                        <div style={{ fontSize: 11, color: 'var(--semi-color-text-2)', marginBottom: 4 }}>{item.label}</div>
                        <div style={{ fontSize: 15, fontWeight: 'bold', color: item.color }}>
                            {item.isCount ? (item.value || 0) : formatAmountZhCn(item.value || 0)}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return <>
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', margin: '5px' }}>
            <Popover
                content={renderStatDetailContentPlan(statDataObj)}
                trigger="hover"
                position="bottomLeft"
                showArrow
            >
                <a style={{ marginRight: 12, whiteSpace: 'nowrap', color: 'var(--semi-color-link)', cursor: 'pointer' }}><IconBarChartHStroked style={{marginRight: 4}}/>统计详情</a>
            </Popover>
            <div style={{ flex: 1 }}>
                <StatCards />
            </div>
        </div>
        <PaidDateQuickButtons />
        <Crud
            getCrudApi={(api) => { setCrudApi(api); crudApiRef.current = api; }}
            getFilterFormApi={(_crudApi: any, formApi: any) => { filterFormRef.current = formApi; }}
            canUpdate={false}
            canCreate={false}
            canDelete={false}
            canExport={true}
            treeTable={true}
            initParams={initParams}
            initFilterValues={initFilterValues}
            name="每日出款"
            entityKey="repaymentPlan/statPaidPlanByDate"
            pageSize={500}
            rowActionWidth={0}
            fetchDataAfterMethod={queryStatCount}
            cols={cols}
        />
    </>
}
